module.exports = __webpack_public_path__ + "img/stamp_none@2x.0719cb23.png";